/** Shared crescent silhouette for the wordmark and the lobby's lunar artwork. */
export function MoonMark({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="currentColor" aria-hidden="true">
      <path d="M72 12A42 42 0 1 0 88 72A35 35 0 0 1 72 12Z" />
      <path d="m79 24 2.5 7.5L89 34l-7.5 2.5L79 44l-2.5-7.5L69 34l7.5-2.5Z" />
    </svg>
  );
}
